import React, {PureComponent} from 'react';
import Progress from './progress';
import I18n from 'app/i18n';
import {getPromoLinkPath, isGuest} from 'app/utils';
import {Link} from 'react-router-dom';
import TableLeaders from 'app/components/promo_action/compendium/table_leaders';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class FinishedComponent extends PureComponent {
    get isRenderable() {
        const {finished} = this.props;

        return finished;
    }


    render() {
        if (!this.isRenderable) {
            return null;
        }

        return <>
            <div className="compendium-aside__content compendium-aside__content_left">
                <Progress
                    {...this.props}
                    styleTop={0}
                />
                <div className="compendium-aside__links">
                    {!isGuest() && <div className="compendium-aside__link">
                        <SpriteIcon name="#svg-my-predictions" size={{height: 16, width: 16}}/>
                        <Link
                            to={getPromoLinkPath('/my_predictions')}
                        >
                            {I18n.t('compendium.my_predictions_title')}
                        </Link>
                    </div>}
                    <div className="compendium-aside__link">
                        <SpriteIcon name="#svg-table-leaders" size={{height: 16, width: 16}}/>
                        <Link to={getPromoLinkPath('/rating')}>
                            {I18n.t('compendium.results_table')}
                        </Link>
                    </div>
                </div>
            </div>
            {this.props.isLeaderboardAvailable &&
                <TableLeaders {...this.props}/>
            }
        </>;
    }
}
